<template>

  <m-not-found-1/>

</template>

<script>
export default {
  name: "NotFound",

};
</script>
<style scoped>


</style>